import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;
import generateFlatMethods from "./method";

const URL = getOrigin("www") + "/uaapi/user/";

//用户vip信息
export function getVipInfo(config) {
  return XtAxios.get(URL + `private/userVip/info`, config);
}

//普通用户vip list
export function getNormalVipList(config) {
  return XtAxios.get(URL + `public/vip/list`, config);
}

const baesUrl = getOrigin("www") + "/uaapi";

const {
  get,
  put,
  post,
  del,
} = generateFlatMethods(baesUrl);

const requestGenerate = (method, url) => (data, config) => method(url, data, config);

// 获取用户信息
export const getUserInfo = requestGenerate(get, '/user/user/getUserInfo');